import { createI18n } from "vue-i18n";
import es from "./locales/es.js";
import en from "./locales/en.js";

const i18n = createI18n({
  legacy: false,
  locale: "es",
  fallbackLocale: "es",
  globalInjection: true,
  messages: {
    es,
    en,
  },
  // Configuracions específiques per a producció
  missingWarn: false,
  fallbackWarn: false,
  // Assegurar que les traduccions es serialitzen correctament
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

// Exposa globalment només en desenvolupament per a debugging
if (typeof window !== "undefined" && import.meta.env.DEV) {
  window.$i18n = i18n.global;
}

export default i18n;
